import { storableError } from '../../util/errors';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { createImageVariantConfig } from '../../util/sdkLoader';
import { parse } from '../../util/urlHelpers';
import { getOrderNumber, stripeCustomer } from '../CheckoutPage/CheckoutPage.duck';

// Pagination page size might need to be dynamic on responsive page layouts
// Current design has max 3 columns 12 is divisible by 2 and 3
// So, there's enough cards to fill all columns on full pagination pages
const RESULT_PAGE_SIZE = 20;

// ================ Action types ================ //

export const CART_LISTING_REQUEST = 'app/CartPage/CART_LISTING_REQUEST';
export const CART_LISTING_SUCCESS = 'app/CartPage/CART_LISTING_SUCCESS';
export const CART_LISTING_ERROR = 'app/CartPage/CART_LISTING_ERROR';

// ================ Reducer ================ //

const initialState = {
  pagination: null,
  queryParams: {},
  queryInProgress: false,
  cartListingError: null,
  userListingRefs: [],
};

const cartPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case CART_LISTING_REQUEST:
      return {
        ...state,
        queryInProgress: true,
        cartListingError: null,
      };
    case CART_LISTING_SUCCESS:
      return { ...state, queryInProgress: true, userListingRefs: payload.listingRefs, pagination: payload.data.meta, };

    case CART_LISTING_ERROR:
      return { ...state, queryInProgress: false, cartListingError: payload };

    default:
      return state;
  }
};

export default cartPageReducer;

// ================ Action creators ================ //

export const cartListingRequest = queryParams => ({
  type: CART_LISTING_REQUEST,
  payload: queryParams,
});

export const cartListingSuccess = (listingRefs, response) => ({
  type: CART_LISTING_SUCCESS,
  payload: { listingRefs, data: response.data },
});

export const cartListingError = e => ({
  type: CART_LISTING_ERROR,
  error: true,
  payload: e,
});

export const searchBagListings = (ids, search, config) => async (dispatch, getState, sdk) => {
  dispatch(cartListingRequest());
  const queryParams = parse(search, {
    latlng: ['origin'],
    latlngBounds: ['bounds'],
  });

  const { page = 1 } = queryParams;
  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;

  const params = {
    ids: ids || [],
    include: ['author', 'images', 'currentStock'],
    'fields.image': [
      'variants.scaled-small',
      'variants.scaled-medium',
      `variants.${variantPrefix}`,
      `variants.${variantPrefix}-2x`,
    ],
    ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
    'limit.images': 1,
    perPage: RESULT_PAGE_SIZE,
    page,
  };
  try {
    const response = await sdk.listings.query(params);
    const { data: { data = {} } = {} } = response || {};
    const listingRefs = !!data?.length && data?.map(({ id, type }) => ({ id, type }));
    dispatch(addMarketplaceEntities(response));
    dispatch(cartListingSuccess(listingRefs, response));

    return response;
  } catch (e) {
    dispatch(cartListingError(storableError(e)));
    throw e;
  }
};

export const loadData = (params, search, config) => async (dispatch, getState, sdk) => {
  try {
    const currentUser = await dispatch(fetchCurrentUser());
    const { bagItems } = currentUser?.attributes?.profile?.protectedData || {};
    dispatch(searchBagListings(bagItems, search, config));
    dispatch(stripeCustomer())
    dispatch(getOrderNumber())
  } catch (e) {
    dispatch(cartListingError(storableError(e)));
  }
};
